import { Box } from "@mui/material";

import { Footer } from "components/Footer";
import { PublicAppBar, appBarHeight } from "components/PublicAppBar";
import { useFloatingBanners } from "hooks/useFloatingBanners";
import { ChildrenProps } from "types/props";

export type PublicLayoutProps = ChildrenProps;

export const PublicLayout = ({ children }: PublicLayoutProps) => {
  const { FloatingBannersModal } = useFloatingBanners();
  return (
    <>
      <PublicAppBar />
      <Box
        component="main"
        sx={{
          flex: 1,
          paddingTop: appBarHeight,
        }}
      >
        <FloatingBannersModal />
        {children}
      </Box>
      <Footer />
    </>
  );
};
